import "@fontsource-variable/source-sans-3";
import "@fontsource-variable/source-serif-4/opsz.css";
import "@fontsource-variable/source-code-pro";
import { IRMAppProvider } from "context/context";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
// import store from "./app/_store/store";
// import { Provider } from "react-redux";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "./context";
import { restoreGlobalAuthorizationHeader } from "app/services/auth.header.service";
import { startSessionSync } from "app/services/session.sync";

// The session now lives in localStorage, so a tab can boot straight into an existing sign-in.
// Give it the axios header the login flow would have set, and let it follow sign-outs elsewhere.
restoreGlobalAuthorizationHeader();
startSessionSync();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <IRMAppProvider>
        <App />
      </IRMAppProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>,
  // document.getElementById("root")
);
// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
